import { set } from 'immutable'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EditUserAddress } from '../../redux/Slices/UserSlice'
import notify from '../UseNotification'

const UseEditAddressUser = (item) => {

    const egyptPhoneRegex = /^(010|011|012|015)\d{8}$/;
    const dispatch = useDispatch()
    const [EditShow, setEditShow] = useState(false)
    const [EditAddressTitle, setEditAddressTitle] = useState(item.alias)
    const [EditaddressInDetails, setEditaddressInDetails] = useState(item.details)
    const [EditphoneNumber, setEditphoneNumber] = useState(item.phone)
    const [loading, setLoading] = useState(true)
    const { editAddress } = useSelector(state => state.UserReducer)
    const [isPress, setIsPress] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false)

    // handle edit show
    const handleEditShow = () => {
        setEditShow(true)
    }

    // handle edit close
    const handleEditClose = () => {
        setEditShow(false)
    }

    // handle change address title
    const changeEditAddressTitle = (e) => {
        setEditAddressTitle(e.target.value)
        if (e.target.value === "") {
            setIsFormValid(false)
        } else {
            setIsFormValid(true)
        }
    }

    // handle change address details
    const changeEditAddressInDetails = (e) => {
        setEditaddressInDetails(e.target.value)
        if (e.target.value === "") {
            setIsFormValid(false)
        } else {
            setIsFormValid(true)
        }
    }

    // handle change phone
    const changeEditPhoneNumber = (e) => {
        setEditphoneNumber(e.target.value)
        if (e.target.value === "" || !e.target.value.match(egyptPhoneRegex)){
            setIsFormValid(false)
        }else{
            setIsFormValid(true)
        }
    }

    // handle validate address title
    const validateTitle = (e) => {
        if (e.target.value === "") {
            notify("please, enter the address title", "warn")
        }
    }

    // handle validate address details
    const validateDetails = (e) => {
        if (e.target.value === "") {
            notify("please, enter the address details", "warn")
        }
    }

    // handle validate phone number
    const validatePhoneNumber = (e) => {
        if (e.target.value === "") {
            notify("you must enter phone", "warn")
        } else if (!e.target.value.match(egyptPhoneRegex)) {
            notify("phone is not egyption number", "warn")
        }
    }

    // validate inputs
    const Validate = () => {
        if (EditAddressTitle === "") {
            notify("please, enter the address title", "warn")
            return false;
        }
        else if (EditaddressInDetails === "") {
            notify("please, enter the address details", "warn")
            return false;
        }
        else if (EditphoneNumber === "") {
            notify("you must enter phone", "warn")
            return false;
        }
        else if (!EditphoneNumber.match(egyptPhoneRegex)) {
            notify("phone is not egyption number", "warn")
            return false;
        }
        return true;
    }

    // handle edit address
    const HandleEditAddress = async () => {
        setIsPress(true)
        if (!Validate()) {
            return;
        }
        handleEditClose()
        setLoading(true)
        await dispatch(EditUserAddress({
            id: item._id,
            data: {
                alias: EditAddressTitle,
                details: EditaddressInDetails,
                phone: EditphoneNumber,
                city: "",
                postalCode: ""
            }
        }))
        setLoading(false)
    }

    // handle the edit address request response 
    useEffect(() => {
        if (loading === false) {
            setIsPress(false)
            if (editAddress && editAddress.status === 200) {
                notify("Address updated", "success")
                window.location.reload(false)
            } else {
                notify("Please try again", "success")
            }
        }
    }, [loading])
    return [isFormValid, loading, isPress, validateTitle, validateDetails, validatePhoneNumber, HandleEditAddress, handleEditShow, handleEditClose, EditShow, EditAddressTitle, changeEditAddressTitle, EditaddressInDetails, changeEditAddressInDetails, EditphoneNumber, changeEditPhoneNumber]
}

export default UseEditAddressUser
